import React, { FC } from 'react';
import { classNames } from '../../../../utils';
import { CalendarRangeHighlightProps } from '../../types';

const CalendarRangeHighlight: FC<CalendarRangeHighlightProps> = ({
  isVisible = false,
  isFirstDayOfWeek = false,
  isFirstInRange = false,
  isLastDayOfWeek = false,
  isLastInRange = false,
  children,
}): JSX.Element => {
  return (
    <div
      className={classNames(
        'h-9 leading-9 my-2 mx-auto',
        isVisible &&
          isFirstInRange &&
          'bg-gradient-to-l from-green-lightest via-transparent ',
        isVisible &&
          isLastInRange &&
          'bg-gradient-to-r from-green-lightest via-transparent',
        isVisible &&
          isFirstDayOfWeek &&
          !isLastInRange &&
          'bg-gradient-to-l from-green-lightest',
        isVisible && isLastDayOfWeek && 'bg-gradient-to-r from-green-lightest',
        isVisible &&
          !isLastInRange &&
          !isFirstInRange &&
          !isFirstDayOfWeek &&
          !isLastDayOfWeek &&
          'bg-green-lightest',
      )}
    >
      {children}
    </div>
  );
};

export default CalendarRangeHighlight;
